import React from "react";
import ReactDOM from "react-dom/client";
import "@cb/apricot/CBBase";
import "@cb/apricot/CBGrid";
import "@cb/athena-widgets-types";

import App from "src/App";
import reportWebVitals from "src/reportWebVitals";
import "src/index.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <cbw-header app-id="42" site-title="CollegeBoard" skip-target-id="mainContent" use-icon-logo="false"></cbw-header>
    <App />
    <cbw-footer app-id="42"></cbw-footer>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
